import {Component, computed, input} from '@angular/core';

@Component({
  selector: 'lib-tile-loader',
  standalone: true,
  templateUrl: './tile-loader.component.html',
  styleUrl: './tile-loader.component.scss',
})
export class TileLoaderComponent {
  readonly count = input.required<number>();

  protected readonly items = computed(() => [...Array(this.count())
    .keys()]);
}
